import * as React from 'react';
import { OWCOpenDmrContext } from 'src/context/OWCOpenDmrContext';

export const useUserPermission = (permission: string) => {
    const { user } = React.useContext(OWCOpenDmrContext);
    return !!user?.permissions?.includes(permission);
}